import { render, staticRenderFns } from "./SentenceCreateForm.vue?vue&type=template&id=3864a553&"
import script from "./SentenceCreateForm.vue?vue&type=script&lang=js&"
export * from "./SentenceCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports